import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import StickyNoteIcon from '../../../../NRIcons/StickyNoteIcon';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../../../constants/constants';
import moment from 'moment';
import { REMEDIATION_CONSTANTS } from '../../../NRRemediation/NRRemediation.constants';
import { useId } from 'react';

export function RemediationDetailsFormatter({ row, placement = 'left' }) {
  const theme = useTheme();
  const { HEADER } = CONSTANTS.DATE_FORMAT;
  const tooltipId = useId();

  const { justification, description, createdAt, author, response } = row?.currentRemediation || {};
  const { detail, user, createdTime } = row?.remediation || {};
  const { VEX_JUSTIFICATION, VEX_RESPONSES } = REMEDIATION_CONSTANTS;

  const shouldDisplayComponent = !!justification || !!description || !!createdAt || !!author || !!detail || !!response || !!user || !!createdTime;

  if (!shouldDisplayComponent) return null;

  const TooltipContent = () => (
    <Box m={0.5} maxWidth={250}>
      {!!justification && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Justification'} />
          <Typography variant="caption" children={VEX_JUSTIFICATION[justification]} />
        </Box>
      )}
      {!!response && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Response'} />
          <Typography variant="caption" children={VEX_RESPONSES[response]} />
        </Box>
      )}
      {(!!description || !!detail) && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Detail'} />
          <Typography variant="caption" children={description || detail} />
        </Box>
      )}
      {(!!createdAt || !!createdTime) && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Updated On'} />
          <Typography variant="caption" children={moment(createdAt || createdTime).format(HEADER)} />
        </Box>
      )}
      {(!!author || !!user) && (
        <Box display="flex" flexDirection="column">
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Updated By'} />
          <Typography variant="caption" children={author || user} />
        </Box>
      )}
    </Box>
  );

  const tooltipTextParts = [];
  if (justification) tooltipTextParts.push(`Justification: ${VEX_JUSTIFICATION[justification]}`);
  if (response) tooltipTextParts.push(`Response: ${VEX_RESPONSES[response]}`);
  if (description || detail) tooltipTextParts.push(`Detail: ${description || detail}`);
  if (createdAt || createdTime) tooltipTextParts.push(`Updated On: ${moment(createdAt || createdTime).format(HEADER)}`);
  if (author || user) tooltipTextParts.push(`Updated By: ${author || user}`);
  const tooltipText = tooltipTextParts.filter(Boolean).join(' ');

  return (
    <Tooltip placement={placement} title={<TooltipContent />}>
      <Box
        display={'flex'}
        alignItems={'center'}
        ml={theme.spacing(1)}
        tabIndex={0}
        role="img"
        aria-label="Remediation details"
        {...(tooltipText ? { 'aria-describedby': tooltipId } : {})}
      >
        {tooltipText && (
          <Typography id={tooltipId} variant="srOnly">
            {tooltipText}
          </Typography>
        )}
        <StickyNoteIcon color={theme.palette.text.iconInfo} fillOpacity={1} />
      </Box>
    </Tooltip>
  );
}
